// extracted by mini-css-extract-plugin
module.exports = {"news-banner-box":"ce","newsBannerBox":"ce","banner-wrap":"cf","bannerWrap":"cf","banner-title":"cg","bannerTitle":"cg","banner-img-box":"ch","bannerImgBox":"ch"};